/* eslint-disable max-len */
import React from 'react';
import { Typography, Modal, Button } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import Image from '@search/vtbeco-frontend-core/view/common/components/Image';
import classname from '@search/classname/src';

import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { useM2AuthContext } from '@search/auth/src/M2AuthProvider';
import {
    minimalBanksMortgageUrlCreate
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/minimalBanksMortgageUrl';
import {
    useMortgageAppSource
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/MortgageAppSourceContext';
import {
    windowOpen
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/mortgage2/useMortgage2Request';

import Figure1 from './figure1.url.svg';
import Figure2 from './figure2.url.svg';
import Figure3 from './figure3.url.svg';
import Figure4 from './figure4.url.svg';

import './MortgageContainer.css';

const cn = classname.bind(null, 'MortgageContainer');

export function MortgageContainer(props: {} & {
    handleClose: () => void;
    collapsed: boolean;
    mobile?: boolean;
}) {
    const { collapsed, handleClose, mobile } = props;
    const staticPath = useStaticPathConfig();
    const { auth } = useM2AuthContext();
    const sourceMortgage = useMortgageAppSource();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { fullUrl, baseUrl } =
        minimalBanksMortgageUrlCreate({
            isAuthenticated: auth.isAuthenticated,
            source: sourceMortgage
        });

    const onClick = React.useCallback(() => {
        if (typeof window !== 'undefined') {
            sessionStorage?.setItem('mortgagePin', 'close');
        }
        windowOpen(`${baseUrl}/?erid=sKjnGhd4KprWDTakDPgTP3chjmBU6KRLBZiPQCdjuNpDieZ`, { isMobile: mobile });
    }, [ baseUrl, mobile ]);

    const body = (
        <div className={cn('body')}>
            <Typography variant='h3'>
                Оформить ипотеку&nbsp;&mdash; легко и&nbsp;выгодно
            </Typography>
            <div className={cn('body-wrap')}>
                <div className={cn('line')}>
                    <Image
                        url={`${staticPath}${Figure1}`}
                        width={48}
                        height={48}
                    />
                    <div>
                        <Typography variant='primary' bold>Подайте заявку за&nbsp;10&nbsp;минут</Typography>
                        <Typography variant='primary'>Заполните единую анкету. У&nbsp;нас 24&nbsp;банка-партнёра.</Typography>
                    </div>
                </div>
                <div className={cn('line')}>
                    <Image
                        url={`${staticPath}${Figure2}`}
                        width={48}
                        height={48}
                    />
                    <div>
                        <Typography variant='primary' bold>Получите одобрение</Typography>
                        <Typography variant='primary'>Ответы от&nbsp;банков обычно приходят в&nbsp;течение суток.</Typography>
                    </div>
                </div>
                <div className={cn('line')}>
                    <Image
                        url={`${staticPath}${Figure3}`}
                        width={48}
                        height={48}
                    />
                    <div>
                        <Typography variant='primary' bold>Оформите ипотеку</Typography>
                        <Typography variant='primary'>
                            Мы&nbsp;поможем подготовиться к&nbsp;сделке. В&nbsp;банк нужно прийти всего 1&nbsp;раз.
                        </Typography>
                    </div>
                </div>
                <div className={cn('line')}>
                    <Image
                        url={`${staticPath}${Figure4}`}
                        width={40}
                        height={40}
                    />
                    <div>
                        <Typography variant='primary' bold>Индивидуальный подход</Typography>
                        <Typography variant='primary'>
                            Работаем со&nbsp;льготной, семейной, базовой ипотекой и&nbsp;материнским капиталом.
                        </Typography>
                    </div>
                </div>
            </div>
            <Button variant='accent' fullWidth onClick={onClick}>
                Рассчитать ипотеку
            </Button>
            <Typography
                variant='small-alone'
                color='secondary'
            >
                Реклама. ООО «Экосистема недвижимости М2» ИНН 7707430681
            </Typography>
        </div>
    );

    const mobileVariant = (
        <Modal opened={collapsed} onClose={handleClose}>
            <Modal.WideContent header>
                <Typography className={cn('mobile-header')}>
                    Ипотека от&nbsp;7,5%
                </Typography>
            </Modal.WideContent>
            <Modal.Content scrollable>
                {body}
            </Modal.Content>
        </Modal>
    );

    return mobile ? mobileVariant : (
        <div className={cn()}>
            <div className={cn('header')}>
                <Typography>
                    Ипотека от&nbsp;7,5%
                </Typography>
                <div className={cn('header-close')}>
                    <button className={cn('header-close')} onClick={handleClose}>
                        <Icon name='times' size='s' />
                    </button>
                </div>
            </div>
            {body}
        </div>
    );
}
